



















import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator'
import { NEWS_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { NEWS_PATH } from '~/assets/config/path'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentNavigationPagination from '~/components/navigation/pagination.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentArticleItem from '~/components/articles/article-item.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
const pageStore = namespace('page')
@Component({
  watchQuery: ['page'],
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentIntersect,
    ComponentArticleItem,
    ComponentTypographyH1,
    ComponentNavigationPagination,
  },
})
export default class pageNews extends Vue {
  private async asyncData({
    $axios,
    route,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
  }) {
    const response = await $axios.$get(NEWS_API, {
      params: {
        page: route.query.page || '1',
      },
    })

    return response
  }

  private breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Новости',
      url: NEWS_PATH,
    },
  ]

  private styleSpacer!: IStyle
  private $style!: IStyle
  private pages = 1

  private get classList() {
    return {
      [this.$style.list]: true,
      [this.styleSpacer.mb24]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private meta: IMeta | null = null

  @Watch('meta', { immediate: true })
  private metaHandler(val: IMeta) {
    if (val) {
      this.setMeta(val)
    }
  }
}
